import axios from "axios";
import { API_BASE_URL } from "utils/api";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getWhatsappStatus = async () => {
  const response = await axiosInstance.get("/api/configuration/whatsapp/status");
  return response.data;
};

export const getWhatsappConnectUrl = async () => {
  const response = await axiosInstance.get("/api/configuration/whatsapp/connect");
  return response.data.data || response.data;
};

export const disconnectWhatsapp = async () => {
  const response = await axiosInstance.post("/api/configuration/whatsapp/disconnect");
  return response.data;
};

export const manualConnectWhatsapp = async (credentials) => {
  const response = await axiosInstance.post("/api/configuration/whatsapp/manual-connect", credentials);
  return response.data;
};

const configurationService = {
  getWhatsappStatus,
  getWhatsappConnectUrl,
  manualConnectWhatsapp,
  disconnectWhatsapp,
};

export default configurationService;
